import { render, staticRenderFns } from "./crossChainTransfer.vue?vue&type=template&id=fe5c7200&scoped=true"
import script from "./crossChainTransfer.vue?vue&type=script&lang=js"
export * from "./crossChainTransfer.vue?vue&type=script&lang=js"
import style0 from "./crossChainTransfer.vue?vue&type=style&index=0&id=fe5c7200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5c7200",
  null
  
)

export default component.exports